'use strict';

/* global angular */

const ProcessingJobsController = require('./ProcessingJobsController');
const ProcessingJobDetailController = require('./ProcessingJobDetailController');
const StartFromFilter = require('./filters/startFromFilter');
const FileTypeFilter = require('./filters/FileTypeFilter');

require('./map');
require('./dialogs');

angular
.module('manager.processingJobs', ['ngTable', 'manager.processingJobs.job.map'])
.controller('ProcessingJobsController', ProcessingJobsController)
.controller('ProcessingJobDetailController', ProcessingJobDetailController)
.filter('startFrom', StartFromFilter)
.filter('fileType', FileTypeFilter)
.run();



// WEBPACK FOOTER //
// ./src/app/manager/processing/index.js